<mat-card class="oauth-clients-card">
  @if (!allowed) {
  <mat-card-content>
    <p class="denied">Kun superadmin har adgang til OAuth-klienter.</p>
  </mat-card-content>
  } @else {
  <mat-card-header>
    <mat-card-title>OAuth / OIDC-klienter</mat-card-title>
    <span class="spacer"></span>
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="loading"
      (click)="openCreate()"
    >
      <mat-icon>add</mat-icon>
      Opret klient
    </button>
  </mat-card-header>

  <mat-card-content>
    @if (errorMessage) {
    <p class="error-banner">{{ errorMessage }}</p>
    }

    @if (loading) {
    <p>Henter klienter…</p>
    } @else {
    <table mat-table [dataSource]="dataSource" class="clients-table">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Navn</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <ng-container matColumnDef="client_id">
        <th mat-header-cell *matHeaderCellDef>Client ID</th>
        <td mat-cell *matCellDef="let row">
          <code>{{ row.client_id }}</code>
        </td>
      </ng-container>

      <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef>Aktiv</th>
        <td mat-cell *matCellDef="let row">
          {{ row.enabled ? 'Ja' : 'Nej' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="redirect_uris">
        <th mat-header-cell *matHeaderCellDef>Redirect URIs</th>
        <td mat-cell *matCellDef="let row">
          <span class="uri-list" [matTooltip]="redirectTooltip(row)">
            {{ redirectSummary(row) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="has_client_secret">
        <th mat-header-cell *matHeaderCellDef>Secret</th>
        <td mat-cell *matCellDef="let row">
          {{ row.has_client_secret ? 'Ja' : 'Nej' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="product_key">
        <th mat-header-cell *matHeaderCellDef>Product</th>
        <td mat-cell *matCellDef="let row">{{ row.product_key || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row" class="actions-cell">
          <button
            mat-icon-button
            type="button"
            matTooltip="Rediger"
            (click)="openEdit(row)"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            type="button"
            matTooltip="Rotér client secret"
            [disabled]="actionId === row.id"
            (click)="rotateSecret(row)"
          >
            <mat-icon>vpn_key</mat-icon>
          </button>
          <button
            mat-icon-button
            type="button"
            color="warn"
            matTooltip="Deaktiver"
            [disabled]="!row.enabled || actionId === row.id"
            (click)="disableClient(row)"
          >
            <mat-icon>block</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    @if (!loading && dataSource.data.length === 0) {
    <p class="empty">Ingen OAuth-klienter endnu.</p>
    }
    }
  </mat-card-content>
  }
</mat-card>
